import * as React from 'react';
import { useHeaderRowContext } from '../../../HeaderRow/context/hooks/useHeaderRowContext.js';

/**
 * Hook to register caption presence with header context
 */
var useRegisterCaption = function useRegisterCaption() {
  var _useHeaderRowContext = useHeaderRowContext(),
    setHasCaption = _useHeaderRowContext.setHasCaption;
  React.useEffect(function () {
    setHasCaption === null || setHasCaption === void 0 || setHasCaption(true);
    // Clean up when component unmounts
    return function () {
      return setHasCaption === null || setHasCaption === void 0 ? void 0 : setHasCaption(false);
    };
  }, [setHasCaption]);
};

export { useRegisterCaption };
//# sourceMappingURL=useRegisterCaption.js.map
